export default __webpack_public_path__ + "07997188276d702481d85e1857a15bbc.png";